export default __webpack_public_path__ + "a7b7f4755a618ee22850085a6bd8cf90.ttf";